/**
 * "Do we hold the booking detail payload for THIS order?"
 *
 * The one question every booking-detail screen has to answer before it renders
 * a body — and the reason it exists as one importable predicate is that the
 * three use-case screens (venue, apartment/room, non-room) each used to answer
 * a *different* question instead: "is a request in flight?" (`isFetching`).
 *
 * Those are not the same question, and the difference is two bugs:
 *  - a request that is no longer in flight but whose hook still reports
 *    `isFetching` leaves a spinner that never resolves, on a booking whose
 *    payload is already in hand;
 *  - `isFetching` is also true for every *background* refetch — after an edit,
 *    a setup-time change or a cancel — so a page that was already rendered
 *    blanks out and comes back.
 *
 * Keying on the id additionally covers the case an in-flight flag cannot see at
 * all: the payload we hold belongs to the booking opened *before* this one
 * (same component instance, new `:bookingId`), which must never be shown under
 * the new order's URL.
 */
export const hasBookingDetailsForOrder = (
    details: { id?: string } | null | undefined,
    orderId: string | undefined | null,
): boolean => Boolean(orderId) && details?.id === orderId;
